import { axiosClient } from "./axiosClient";
import { WallComment, WallPost } from "./groupWallApi";

// ── Posty portalowe (niegrupowe) — feed Społeczności. Tworzyć może tylko zweryfikowany użytkownik. ──
export type CommentsPolicy = "all" | "verified" | "none";

export const createPortalPost = (body: string, commentsPolicy: CommentsPolicy) =>
  axiosClient.post<WallPost>("portal_posts", { body, comments_policy: commentsPolicy });

// Permalink pojedynczego posta portalowego (deep-link z powiadomień).
export const getPortalPost = (id: string) => axiosClient.get<WallPost>(`portal_posts/${id}`);

export const deletePortalPost = (id: string) => axiosClient.delete(`portal_posts/${id}`);

export const reactPortalPost = (id: string) =>
  axiosClient.post<{ reacted: boolean; reactions_count: number }>(`portal_posts/${id}/react`);

export const createPortalComment = (postId: string, body: string, parentId?: string) =>
  axiosClient.post<WallComment>(`portal_posts/${postId}/comments`, { body, parent_id: parentId });

export const deletePortalComment = (commentId: string) => axiosClient.delete(`portal_comments/${commentId}`);
